import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import SponsorMarquee from "@/components/SponsorMarquee";
import NextMatch from "@/components/NextMatch";
import UpcomingMatches from "@/components/UpcomingMatches";
import Squad from "@/components/Squad";
import PlayerOfMonth from "@/components/PlayerOfMonth";
import Gallery from "@/components/Gallery";
import Blog from "@/components/Blog";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

export default function Home() {
  const location = useLocation();

  // Scroll ke section sesuai hash (mis. dari footer di halaman lain: /#skuad)
  useEffect(() => {
    const id = location.hash.slice(1);
    if (!id) return;
    let tries = 0;
    const tick = () => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      } else if (tries++ < 10) {
        setTimeout(tick, 150);
      }
    };
    const t = setTimeout(tick, 150);
    return () => clearTimeout(t);
  }, [location]);

  return (
    <div data-testid="home-page" className="bg-[#050B14] text-white">
      <Navbar />
      <Hero />
      <SponsorMarquee />
      <NextMatch />
      <UpcomingMatches />
      <Squad />
      <PlayerOfMonth />
      <Gallery />
      <Blog />
      <Contact />
      <Footer />
    </div>
  );
}
